export default store => {
  store.subscribe((m, state) => {
  });
};